import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";

import { btnStyOne } from "../ui-elements/styles-button";
import { ImageUpload } from "../image-upload";
import { RespsOne } from "../../interface/onboard";
import { useNotificationService } from "../../hooks/notification";
import { apiApplyForResp } from "../../api/account";
import { useMutation } from "@tanstack/react-query";
import { RepresentativeApplyProps } from "../../interface/api";
import { LoadingButton } from "@mui/lab";
import useResponsive from "../../hooks/useResponsive";
import { PATH_DASHBOARD } from "../../routes/path";
import { useNavigate } from "react-router-dom";

export const RepsTwo = ({ next, resp_data, setResp_data }: RespsOne) => {
  const navigate = useNavigate();
  const [modal_state, setModal_state] = useState(false);
  const { showNotification } = useNotificationService();
  const isMedium = useResponsive("down", "md", "xl");
  const [kyc, setKyc] = useState<File | null>(null);
  const handle_selected_image = (image: { data_url: any; file: File }[]) => {
    setKyc(image[0]?.file);
  };
  const mutation = useMutation({
    mutationFn: (fields: RepresentativeApplyProps) => apiApplyForResp(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(
            data?.details?.message || data.details[0] || "Unknown error",
            "error"
          );
          return;
        }
        return;
      }
      if (data.status === 200) {
        handle_modal();
        showNotification("Details have been submitted", "success");
        navigate(PATH_DASHBOARD.root);
      }
    },
    onError: (error) => {
      console.error(error);
      showNotification("Server error", "error");
    },
  });
  const on_submit = () => {
    if (kyc === null) {
      showNotification("Kindly upload proof of office", "warning");
      return;
    }
    
    mutation.mutate({ ...resp_data, proof_of_office: [kyc] });
  };

  const handle_modal = () => {
    setModal_state(!modal_state);
  };
  return (
    <Box sx={{ width: isMedium ? "100%" : 620, mx: "auto" }}>
      <Box sx={{ my: 2 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            color: "#26203B",
            textAlign: "center",
          }}
        >
          Submit proof of office position
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 400,
            color: "#9C9AA5",
            textAlign: "center",
            width: "90%",
            mx: "auto",
          }}
        >
          To maintain the platform’s authenticity, we require you to upload
          official proof of your position. Rest assured, your data will remain
          secure and confidential.
        </Typography>
      </Box>

      <ImageUpload
        multiple={false}
        showText={false}
        styles={{}}
        onSelect={handle_selected_image}
      />
      <Box sx={{ width: isMedium ? "90%" : "80%", mx: "auto" }}>
        <Stack direction={"row"} justifyContent={"center"}>
          <LoadingButton
            onClick={on_submit}
            loading={mutation.isPending}
            variant="contained"
            sx={{ ...btnStyOne, width: isMedium ? "100%" : "80%" }}
          >
            Submit
          </LoadingButton>
        </Stack>
      </Box>
    </Box>
  );
};
